import { Button } from "@blueprintjs/core"
import { ID } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"

/* Protopia Ecosystem component */
export interface IMoreProps {
    id: ID
    isEnable: boolean
    isOpen: boolean
    onChange: () => void
}
const More = (props: IMoreProps): JSX.Element => {
    return props.isEnable
        ?
        <Button variant="outlined" onClick={ props.onChange } className={`px-2 py-0 btn-small landing-more-${props.id}`}  >
            <div className="small letter-spacing-1 opacity_75">
                {__( !props.isOpen ? "More" : "Close" )}
            </div> 
        </Button>
        :
        <></>
}
export default More